console.log('js/nps.js -> v0.1.0');

$(function() {
	var npsScore = 0;
	$(".nps-confirmation").hide();

	$('.js-nps-value').on('click', function() {
		var score = $(this).data("value");
		npsScore = score;
		var isConfirmationPage = $(".js-nps-container").data('is-confirmation');

		var url = isConfirmationPage ? '/customer/confirmation/nps' : '/review/nps';
		var token = isConfirmationPage ? getUrlParameter('token') : $(".js-nps-container").data('token');

		$.ajax({
			type: 'POST',
			url: url,
			data: '{"score":' + score+', "token" : "' + token+'"}',
			contentType: 'application/json'
		}).done(response => {
			npsSuccess(score);
			dataLayer.push({ nps: { score }});
		})
	});
	$('.js-nps-reply-send').on('click', function() {
		var text = $(".js-nps-reply-text").val();
		var isConfirmationPage = $(".js-nps-container").data('is-confirmation');

		var url = isConfirmationPage ? '/customer/confirmation/submit_nps_text' : '/review/submit_nps_text';
		var token = isConfirmationPage ? getUrlParameter('token') : $(".js-nps-container").data('token');

		$.ajax({
			type: 'POST',
			url: url,
			data: JSON.stringify({
				token: token,
				text: text
			}),
			contentType: 'application/json'
		}).done(response => {
			npsQuestionSuccess();
		})

		return false;
	});

	function npsSuccess(score){

		$(".js-nps-container").hide();
		$(".js-nps-question").fadeIn();
		$(".js-nps-question").attr('id', 'js-nps-post-booking-tracker');
	
		if(score < 7) {
			$(".js-nps-question-bad").show();
	
		} else if(score < 9) {
			$(".js-nps-question-neutral").show();
	
		} else {
			$(".js-nps-question-good").show();
			if ( document.querySelector(".js-post-booking-share") ) {
				$(".js-post-booking-share").show();
			}
			if ( document.querySelector(".js-post-stay-share") ) {
				$(".js-post-stay-share").show();
			}
		}
	}
	
	function npsQuestionSuccess(){
		$(".js-nps-question").hide();
		$("div[data-experiment-name='cp_nps']").hide();
		$(".js-nps-confirmation").fadeIn();
		setTimeout( function(){$(".nps-confirmation").fadeOut(); }, 3000)
		if($('.js-nps-confirmation').hasClass('new')){
			if(npsScore < 9){
				$('.confirmation-subheading-bad').show();
				setTimeout( function(){$(".js-nps-confirmation").fadeOut(); }, 3000)
			}
			else {
				$('.confirmation-subheading').show();
				$('.confirmation-subtext').show();
				$('.confirmation-send').removeClass('hide');	
			}
		}
	}

});


